import React from 'react'
import { renderRoutes } from 'react-router-config'

import PageHeader from '@components/shared/PageHeader'
import PageFooter from '@components/shared/PageFooter'

// store
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
// actions
import * as PRODUCT_ACTION from '@store/products/actions'
import * as SHARED_ACTION from '@store/shared/actions'
import * as LOCATIONS_ACTION from '@store/locations/actions'
import * as USER_ACTION from '@store/user/actions'
import COOKIES from '@helpers/cookies'

// const HandTalk = window['HT']

class App extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      page: '',
    }
  }

  async componentDidMount() {
    COOKIES.setIfEmpty('whatsAppCookiesPersist', JSON.stringify({}))

    if (localStorage.getItem('storedRegion')) {
      this._switchLocation(localStorage.getItem('storedRegion'))
    } else {
      this._getLocation()
    }
    this.setState({
      page: this.props.location.pathname,
    })
    this.props.actions.getAllLocations()
    if (window.dataLayer) {
      await window.dataLayer.push({ event: 'optimize.activate' })
    }

    this._getIP()

    if (!!window && !!window['HT']) {
      const HandTalk = window['HT']

      await new HandTalk({
        // Seu token de acesso
        token: `${ process.env.REACT_APP_HANDTALK_TOKEN }`,
        // Muda o avatar do plugin ["HUGO", "MAYA"]
        avatar: 'MAYA',
        // Muda o alinhamento do plugin ['top', 'center', 'bottom']
        align: 'bottom',
        // Muda o lado do plugin ['right', 'left']
        side: 'left',
        // Muda a opacidade inicial do plugin 0 a 100
        opacity: 100,
        // Inicia o plugin com o modo escuro ativado [true, false]
        highContrast: true,
        // Quando mobile, aplica as seguintes modificações
        mobileConfig: {
          // Muda o alinhamento do plugin ['top', 'center', 'bottom']
          align: 'top',
        },
      })
    }
  }

  componentDidUpdate(prevProps) {
    // this code has to be refactored to work along the route code.
    let route = this.props.location.pathname

    // let isHome = route === '/';
    // console.log('Call BI changing route', route);
    let dataLayer = window['dataLayer']
    if (dataLayer && route !== this.state.page) {
      this.setState({
        page: this.props.location.pathname,
      })
      dataLayer.push({ 'event': 'virtualPageview', 'pageName': route })
    }
  }

  _getLocation = () => {
    this.props.actions.geolocation()
  }
  _switchLocation = (state) => {
    this.props.actions.switchLocation(state)
  }
  _getIP = () => {
    this.props.actions.getIP()
  }

  _removeSvgTitle() {
    if (window && document) {
      const svgList = document.querySelectorAll('#onetrust-consent-sdk svg')

      const removeTitle = svg => {
        const title = svg.querySelector('title')
        if (!!title) {
          svg.removeChild(title)
        }
      }

      Array.from(svgList).map(removeTitle)
    }
  }

  _createCorrectCampaignParams(params) {
    let utmParams = {}

    Object.keys(params).forEach(key => {
      if (key === 'scr' || key === 'utmcsr') {
        utmParams['utm_source'] = params[key]
      } else if (key === 'md' || key === 'utmcmd') {
        utmParams['utm_medium'] = params[key]
      } else if (key === 'cpgn') {
        utmParams['utm_campaign'] = params[key]
      } else if (key === 'trm' || key === 'utmctr') {
        utmParams['utm_term'] = params[key]
      } else if (key === 'cnt' || key === 'utmccn') {
        utmParams['utm_content'] = params[key]
      } else {
        utmParams[key] = params[key]
      }
    })

    return utmParams
  }

  _urlCampaignFormat(searchTerms, urlBrowser) {
    const urlSearchParams = new URLSearchParams(searchTerms)
    const params = Object.fromEntries(urlSearchParams.entries())
    let urlCampaign = ''

    let newParams = this._createCorrectCampaignParams(params)

    if (newParams) {
      const queryString = Object.keys(newParams).map(key => key + '=' + newParams[key]).join('&')
      urlCampaign = encodeURI(urlBrowser.protocol + '//' + urlBrowser.host + urlBrowser.pathname + '?' + queryString)
    }

    return urlCampaign
  }

  _campaignUrlValidate() {
    let campaignURL = ''
    const gaTags = COOKIES.get('__utmz')

    const urlBrowser = window.location
    const searchTerms = urlBrowser.search
    const urlSearchParams = new URLSearchParams(searchTerms)
    const params = Object.fromEntries(urlSearchParams.entries())

    const savedCampaignParams = localStorage.getItem('campaign-params')
    
    if (searchTerms && !params.idimovel) {
      campaignURL = this._urlCampaignFormat(searchTerms, urlBrowser)
    } else if (gaTags && !params.idimovel && !savedCampaignParams) {
      campaignURL = this._urlCampaignFormat(gaTags, urlBrowser)
    } else {
      if (savedCampaignParams) {
        campaignURL = savedCampaignParams
      } else {
        campaignURL = encodeURI(urlBrowser.protocol + '//' + urlBrowser.host + urlBrowser.pathname + '?utm_campaign=(not set)&utm_content=undefined&utm_medium=(none)&utm_source=(direct)&utm_term=undefined')
      }
    }

    localStorage.setItem('campaign-params', campaignURL)
  }

  render() {
    this._campaignUrlValidate()

    let isHome = this.props.location.pathname === '/'
    let notLP = this.props.location.pathname.split('/')[1] !== 'lp' && this.props.location.pathname.split('/')[1] !== 'indique'

    this._removeSvgTitle()

    return (
      <div>

        {notLP &&
          <PageHeader location={this.props.location} isHome={isHome} />
        }

        {renderRoutes(this.props.route.routes)}

        {notLP &&
          <PageFooter location={this.props.location} />
        }

      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    simulatorActived: state.shared.simulatorActived,
    region: state.shared.region,
    locations: state.locations.estados,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators({
      ...SHARED_ACTION,
      ...PRODUCT_ACTION,
      ...LOCATIONS_ACTION,
      ...USER_ACTION,
    }, dispatch),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(App)



// WEBPACK FOOTER //
// ./src/components/App.js